import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromPreferences from './preference-gps.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromPreferences.preferencesGPSFeatureKey,
      fromPreferences.reducer
    ),
  ],
})
export class PreferencesGPSModule {}
